import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { CustomFormsModule } from 'ngx-custom-validators';

/* Local components */
import { KidsComponent } from './kids.component';
import { KidsHomeComponent } from './components/home/kids-home.component';
import { KidsAttachedComponent } from './components/attached/kids-attached.component';
import { KidsRankingComponent } from './components/ranking/list/kids-ranking.component';
import { KidsRankingClassifComponent } from './components/ranking/classification/kids-ranking-classif.component';

/* Routes */
import { KidsRoutingModule } from './kids-routing.module';

/* Interceptor */
import { Interceptor } from 'src/app/core/interceptors/http-request-interceptor';
import { ThemeModule } from 'src/app/@theme/theme.module';

@NgModule({
    declarations: [
        KidsComponent,
        KidsHomeComponent,
        KidsAttachedComponent,
        KidsRankingComponent,
        KidsRankingClassifComponent,
    ],
    imports: [CommonModule, RouterModule, KidsRoutingModule, Interceptor, ThemeModule],
    providers: [],
})
export class KidsModule {}
